import styled, {css} from "styled-components";
import {device} from "../../themes/Breakpoints";


export const DraftRoomContainer= styled.div`
    font-family: "Saira Semi Condensed", sans-serif;
    padding: 27px 0;
    width: 100%;
    border-radius: 12px;
    background: #FFF;
    display: flex;
	overflow-x: auto;
`;

export const DraftRoomColumn= styled.div`
    padding-right: 37px;
    border-right: 1px solid #E9EBEF;
    margin-right: 37px;
    display: flex;
    flex-direction: column;
    width: 100%;
    .title{
        color: #000;
        font-family: "Saira Semi Condensed", sans-serif;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 20px;
    }
    &:last-child {
        border-right: none;
        margin-right: 0;
        padding-right: 0; 
		max-height: 2200px;
		overflow-y: auto;
    }
	.finish-btn {
		background: #007bff;
		color: white;
		padding: 12px 24px;
		font-size: 18px;
		border: none;
		border-radius: 8px;
		cursor: pointer;
		margin-top: 20px;
	}
	.finish-btn:hover {
		background: #0056b3;
	}

`;

export const DraftSearch = styled.div`
	max-width: 538px;
	width: 100%;
	padding: 9px 12px;
	background: #ffffff;
	border-radius: 3px;
	border: 1px solid #d4d4d4;
	display: flex;
	justify-content: space-between;
	margin-bottom: 24px;
	.searchIcon {
		width: 24px;
		height: 24px;
		cursor: pointer;
	}
	input {
		width: 100%;
		border: none;
		color: #3e464f;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 16px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
	}
	input:focus {
		border: none;
		outline: none;
	}
  @media only screen and (max-width: 767px) {
    margin-bottom: 12px;
  }
`;

export const NumWrapper = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 24px;
    padding-bottom: 12px;
    border-bottom: 1px solid #E9EBEF;
    margin-bottom: 12px;
	.trades-btn button {
		background: #004ea3;
		border-radius: 4px;
		padding: 12px 24px;
		font-weight: 400;
		border: none;
		color: #fff;
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		align-items: center;
		margin: 0 auto;
		cursor: pointer;
		justify-content: center;
	}
	@media only screen and (max-width:767px) {
		gap: 8px;
		justify-content: center;
		margin-top: 18px
	}
`;

export const NumItem = styled.div`
	min-width: 45px;
	height: 32px;
	border: 1px solid #989ea4;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	padding: 5px 10px;
	${props =>
    props.backColor &&
    css`
			background-color: ${props => props.backColor};
			border: none;
		`}

	&.active {
		border: 2px solid #004ea3;
	}
	span {
		color: #0e1118;
		font-size: 18px;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-weight: 400;
	}
`;

export const DraftPlayerItem = styled.div`
	max-width: 538px;
	width: 100%;
	padding: 8px 24px;
	background-color: ${props => (props.backColor ? `${props.backColor}` : '#fff')};
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 12px;
	margin-bottom: 16px;

	.single-inside {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 4px;
	}
	.first {
		width: 10%;
	}
	.second {
		width: 10%;
	}
	.third {
		width: 35%;
	}
	.fourth {
		//width: 15%;
        width: fit-content;
	}
	.name {
		color: #767676;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
	}
	.value {
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
	}
	.name-blue {
		color: #00438b;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
	}
	.value-blue {
		color: #00438b;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 500;
		line-height: 30px;
		width: 30%;
	}
	.single-position {
		border-radius: 8px;
		border: 2px solid #767676;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		justify-content: center;
		align-items: center;
		color: #000;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 20px;
		font-style: normal;
		font-weight: 400;
		line-height: 36px;
		text-transform: uppercase;
		padding: 4px 10px;
	}
	button {
		padding: 6px 24px;
		border-radius: 3px;
		background: #004ea3;
		color: #fff;
		font-family: 'Saira Semi Condensed', sans-serif;
		font-size: 19px;
		font-style: normal;
		font-weight: 500;
		line-height: 24px;
		cursor: pointer;
	}
	button:disabled {
		cursor: not-allowed;
	}
	
  @media only screen and (max-width: 1024px) {
    padding: 8px;
  }
  @media only screen and (max-width: 1023px) {
    flex-wrap: wrap;
    .name {
      //font-size: 20px;
      line-height: 12px;
    }
    .value {
      //font-size: 20px;
      line-height: 24px;
      text-align: center;
    }
    .name-blue {
      line-height: 24px;
    }
    .value-blue {
      line-height: 24px;
      text-align: center;
    }
    .first {
      margin-left: 5px;
    }
  }
  @media ${device.tabletL} {
    .first {
      width: 15%;
    }
    .second {
      width: 15%;
    }
    .third {
      width: 30%;
    }
  }

  @media ${device.tablet} {
    .first {
      width: 15%;
    }
    .second {
      width: 15%;
    }
    .third {
      width: 30%;
    }
  }
  @media only screen and (max-width: 767px) {
    min-width: 250px;
    justify-content: space-evenly;
  }
`;

export const DraftPlayers = styled.div`
	border-top: 1px solid #d4d4d4;
	padding-top: 40px;
	margin-top: 26px;
	margin-bottom: 40px;
	width: 100%;
	display: flex;
	flex-direction: column;
  @media only screen and (max-width: 768px) {
    margin-top: 18px;
    margin-bottom: 2px;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: unset;
    gap: 25px;
    //max-width: 650px;
    overflow-x: auto;
  }
`;
